<template>
    <form class="kt-form" @submit.prevent="create($event, query)">
        <kt-form-section class="row">
            <kt-form-group class="col-4">
                <kt-form-label for="hashid">
                    {{ $t('online_contract.contract_type') }}
                </kt-form-label>
                <select id="title" class="form-control kt-selectpicker" @change="setContent" name="hashid"
                        v-model="query.hashid">
                    <option
                        v-bind:key="index"
                        v-for="(item, index) in templates"
                        v-bind:value="item.hashid"
                    >
                        {{ item.title }}
                    </option>
                </select>
            </kt-form-group>
            <kt-form-group class="col-4">
                <kt-form-label for="payment_status">
                    {{ $t('online_contract.payment_status_title') }}
                </kt-form-label>
                <select id="payment_status" class="form-control kt-selectpicker" name="payment_status"
                        v-model="query.payment_status">
                    <option
                        v-bind:key="index"
                        v-for="( item, index) in paymentStatus"
                        v-bind:value="item"
                    >
                        {{ paymentStatusStr.get(item) }}
                    </option>
                </select>
            </kt-form-group>

            <kt-form-group class="col-4">
                <kt-form-label for="sign_type">
                    {{ $t('online_contract.sign_type') }}
                </kt-form-label>
                <select id="sign_type" class="form-control kt-selectpicker" name="sign_type"
                        v-model="query.sign_type">
                    <option
                        v-bind:key="index"
                        v-for="( item, index) in signType"
                        v-bind:value="item"
                    >
                        {{ signTypeStr.get(item) }}
                    </option>
                </select>
            </kt-form-group>
            <kt-form-group class="col-4">
                <kt-form-label for="end_at">
                    {{ $t('online_contract.price') }}
                </kt-form-label>
                <amount-input
                    :item_id="`amount`"
                    :item_name="`amount`"
                    :item="price"
                ></amount-input>
            </kt-form-group>
            <kt-form-group class="col-4">
                <kt-form-label for="start_at">
                    {{ $t('online_contract.start_at') }}
                </kt-form-label>
                <datePicker
                    id="start_at"
                    name="start_at"
                    format="YYYY-MM-DD"
                    display-format="dddd jDD jMMMM jYYYY"
                    input-class="form-control"
                    v-model="query.start_at" type="date"/>
            </kt-form-group>
            <kt-form-group class="col-4">
                <kt-form-label for="end_at">
                    {{ $t('online_contract.end_at') }}
                </kt-form-label>
                <datePicker
                    id="end_at"
                    name="end_at"
                    format="YYYY-MM-DD"
                    display-format="dddd jDD jMMMM jYYYY"
                    input-class="form-control"
                    v-model="query.end_at" type="date"/>
            </kt-form-group>
        </kt-form-section>
        <kt-form-group>
            <kt-form-label for="content">
                {{ $t('online_contract.content') }}
            </kt-form-label>

            <ckeditor :editor="editor"
                      id="content"
                      name="content"
                      v-model="query.content"
                      :config="editorConfig"
                      tag-name="content"
            >
            </ckeditor>
        </kt-form-group>


        <kt-form-action class="mt-4">
            <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_button">
                {{ $t('btn.submit') }}
            </button>
        </kt-form-action>
    </form>

</template>

<script>
import $ from 'jquery'
import {KTApp} from '@/plugins/core/app'
import {KTUtil} from '@/plugins/core/util'
import {onlineContractService, ticketService} from '@/common/api.service'
import {editorConfig} from '@/constants/ckeditorConfigs'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import {i18n} from "@/plugins/i18n";
import {paymentStatus, paymentStatusStr} from "@/constants/PaymentStatus";
import {signType, signTypeStr} from "@/constants/onlineContractSignType";
import AmountInput from "@/components/custom-elements/amount-input.vue";


export default {
    computed: {
        paymentStatus() {
            return paymentStatus;
        },
        paymentStatusStr() {
            return paymentStatusStr;
        },
        signType() {
            return signType;
        },
        signTypeStr() {
            return signTypeStr;
        },
    },

    components: {
        AmountInput,
        ckeditor: CKEditor.component
    },
    data() {
        return {
            query: {},
            editorConfig: editorConfig,
            editor: ClassicEditor,
            templates: {},
            price: {
                amount: 0
            },

        }
    },
    methods: {
        create(e, query) {
            let form = $(e.target)
            let btn = $('#submit_button')

            form.validate({
                ignore: ":hidden",

                rules: {
                    hashid: {
                        required: true,
                    },
                    payment_status: {
                        required: true,
                    },
                    start_at: {
                        required: true,
                    },
                    end_at: {
                        required: true,
                    },
                    content: {
                        required: true,
                    },
                    sign_type: {
                        required: true,
                    },
                },
            });


            if (!form.valid()) {
                return
            }

            let params = {
                title: query.title,
                content: query.content,
                start_at: query.start_at,
                end_at: query.end_at,
                type: query.type,
                sign_type: query.sign_type,
                payment_status: query.payment_status,
                created_for: this.$route.params.hashid,
                price: this.price.amount,
            }            

            KTApp.progress(btn)
            onlineContractService.contractCreate(params)
                .then(response => {
                    this.showMsg(form, 'success', response.data.message)
                })
                .catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                    KTApp.unprogress(btn)
                })
                .finally(() => {
                    KTUtil.scrollTop()
                    KTApp.unprogress(btn)
                })
        },
        getContractList() {
            onlineContractService.getLists()
                .then(({data}) => {
                    this.templates = data.data.templates;
                    this.price.amount = data.data.price;
                })
        },
        setContent(event) {

            let content = this.templates.find(item => {
                if (item.hashid === event.target.value) {
                    return item;
                }
            })
            this.query.content = content.content;
            this.query.title = content.title;
            this.query.type = content.type;
        },

        reloadSelector() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 2,
                    liveSearch: false,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                });
            }, 1000);
        }
    },

    mounted() {
        this.getContractList();
        this.reloadSelector();
    }
}
</script>

<style>

</style>